// VoltarAoTopo.js — Botão flutuante que reaparece depois de uma rolagem longa.
//
// A home tem mais de 4000 px de altura e o catálogo cresce a cada "Carregar
// mais"; sem isto, voltar ao menu significa arrastar o dedo dezenas de vezes.
//
// Só aparece depois de duas telas de rolagem — antes disso seria só um botão
// tapando conteúdo.
//
// E NÃO APARECE NO LEITOR (18/09/2026). Lá ele não tinha função: "voltar ao
// topo" num livro de 134 páginas é perder o lugar onde se estava lendo, e o
// leitor já guarda e mostra a posição na própria barra. Pior, ele pousava
// justamente sobre o canto onde a barra do grifo abre. Quem o esconde é a
// regra `html.modo-leitura` do App.css, a mesma que tira o cabeçalho e o
// rodapé — daí a classe `voltar-ao-topo` abaixo, que existe só para ser
// alcançada por ela.
import React, { useEffect, useState } from "react";
import { m, AnimatePresence, useReducedMotion } from "motion/react";

const VoltarAoTopo = () => {
  const [visivel, setVisivel] = useState(false);
  const reduzirMovimento = useReducedMotion();

  useEffect(() => {
    const aoRolar = () => setVisivel(window.scrollY > window.innerHeight * 2);
    aoRolar();
    window.addEventListener("scroll", aoRolar, { passive: true });
    return () => window.removeEventListener("scroll", aoRolar);
  }, []);

  return (
    <AnimatePresence>
      {visivel && (
        <m.button
          onClick={() => window.scrollTo({ top: 0, behavior: reduzirMovimento ? "auto" : "smooth" })}
          aria-label="Voltar ao topo"
          // bottom-20 no celular: acima da barra fixa de compra da página de livro
          className="voltar-ao-topo fixed right-4 bottom-20 lg:bottom-6 z-[9997] w-11 h-11 rounded-full
                     bg-insigne-navy-soft border border-line text-white
                     flex items-center justify-center shadow-[0_8px_24px_rgba(0,0,0,0.35)]
                     hover:border-insigne-orange hover:text-insigne-orange transition-colors"
          initial={{ opacity: 0, scale: 0.8 }}
          animate={{ opacity: 1, scale: 1 }}
          exit={{ opacity: 0, scale: 0.8 }}
          transition={{ duration: reduzirMovimento ? 0 : 0.18 }}
        >
          <i className="bi bi-chevron-up text-base" />
        </m.button>
      )}
    </AnimatePresence>
  );
};

export default VoltarAoTopo;
